/**
 * Created by Administrator on 2017/11/16.
 */
var api = '',
  url = '',
  IsPC = '',
  apiNew = '',
  DomainName = 'http://';
  //  DomainName = '//';
  var hostUrl = document.location.href;
  DomainName= 'https:' == document.location.protocol ? "https://": "http://";
    // if (hostUrl.split(':')[0] == 'https') {
    //   DomainName = 'https://';
    // } else {
    //   DomainName = 'http://';
    // }
// $.ajax({
//   url: '../../../../../static/api.json',
//   // url: '../../../../../h5/static/api.json',//打包用
//   async: false,
//   success: function (data) {
//     var hostUrl = document.location.href;

//     if (hostUrl.split(':')[0] == 'https') {
//       DomainName = 'https://'
//     } else {
//       DomainName = 'http://'
//     }
//     api = DomainName + data.status;
//     url = DomainName + data.address;
//     IsPC = data.IsPC;
//     apiNew = DomainName + data.apiNew
//   }
// });

api = DomainName + process.env.ISHOW_API;
apiNew = DomainName + process.env.ISHOW_COMMON_API;
url = DomainName + process.env.ISHOW_WWW;
// console.log(api);
// console.log(apiNew);
// console.log(url);
const UrlName = url + 'h5/';
const GlobalUrl = '/h5/';

const IsPcName = url;

const GetShareInfo = apiNew + 'recommend/getShareInfo'; // 添加title，meta
const UploadToken = api + 'Manage/videoToken'; // 上传VideoToken请求地址
const ImageToken = api + 'Manage/imageToken'; // 上传图片
const WorldToken = api + 'Manage/worldToken';// 上传文档
const GetAliToken = api + "Uploadali/getStsToken";// 阿里token
const RecommendFile = api + 'recommend/file'; // 获取首页推荐作品
const GetRecommend = api + 'recommend/index'; // 获取首页轮播
const GetHomeOnList = api + 'recommend/gethotlist';// 首页正在进行
const GetChannelList = apiNew + 'channel/getChannelList'; // 央视频道
const GetHomeChannel = apiNew + 'channel/getHomeChannel';// 央视频道-首页推荐导航
const GetActivities = api + 'activity/getActivities'; // 活动列表
const GetHotActivity = api + 'activity/getHotActivity'; // 活动热门
const GetActivitieById = apiNew + 'activity/getActivityById';//活 动详情
const UploadNew = api + 'ActivityFile/uploadNew';// 最新上传
const VideoModel = api + 'ActivityFile/recommend';  // 最新上传 -- 优秀作品 d
const VideoLatest = api + '/ActivityFile/latestUploads'; //最新上传视频
const GetGetVCode = api + 'vote/getVCode';  // 生成验证码
const GetValidvode = api + 'vote/validvode'; // 验证验证码
const GetVoteConfig = api + 'vote/getVoteConfig'; // 获取投票配置信息
const GetIpLimit = api + 'vote/ipLimit'; // 投票--ip限制和更新投票数、记录投票信息
const GetGetVoteList = api + 'vote/getVoteList';// 获取投票信息列表
const VoteActivity = api + 'vote/voteActivity';// 获取投票单个文件信息
const GetRelatedVideo = api + 'activityFile/RelatedVideo'; // 活动进展
const FileRelatedVideo = api + 'ActivityFile/fileList';// 相关视频d  ---获取一个活动里的优秀作品/精彩图集
const GetVideoInfo = api + 'Video/getVideoInfo';// 视频详情
const GetImageInfo = api + 'Image/getImageInfo';// 图片详情

/*var GetActivityFormFields = apiNew + 'ActivityFormFields/getActivityFormFieldsList'; */
var GetActivityFormFields = apiNew + 'Activity/getActivityFormFieldsList'; // 新请求报名字段
var GetUserActivityInfo = api + 'ActivityFormFields/getUserActivityInfo'; // 用户信息
var IsJoin = api + 'ActivityFormFields/isJoin'; // isJoin 是否报名

const AddActivityForm = api + 'ActivityForm/addActivityForm';// 添加报名信息，用户报名
const GetActivityForms = api + 'ActivityForm/getActivityForms';// 活动信息列表
const GetActivityFormContent = api + 'ActivityForm/getActivityFormContent';// 我参与--修改报名表
const GetActivitieByUserid = api + 'My/getActivitie';// 我的活动（参与的)
const GetMyActiviteInfo = api + 'My/getMyActiviteInfo';// 我的活动（参与的-搜索)
const GetUploadFileForMe = api + 'Manage/getUploadFile';// 我的活动（上传的）
const GetActivityFileByUserid = api + 'My/getActivityFile';// 我的活动（参与的--管理作品)
const GetActivitieFollowByUserid = api + 'My/getActivitieFollow';// 我的活动（关注的)
const GetActivityMsgList = api + 'ActivityMsg/getActivityMsgList';// 我的活动（@我的)
const UpdataVideoAudit = api + 'Manage/updateVideo';// 编辑视频
const UpdataImageAudit = api + 'Manage/updateImage';// 编辑图片
const DelEteVideo = api + 'Manage/deleteVideo';// 删除上传视频
const DelEteImage = api + 'Manage/deleteImage';// 删除上传图片
const DelActivityFile = api + 'My/delActivityFile';// 删除上传文件
const DelActivityMsgById = api + 'ActivityMsg/delActivityMsgById';// 删除@我的
const DelActivityFollow = api + 'ActivityFollow/delActivityFollow';// 取消关注
const AddActivityFollow = api + 'ActivityFollow/addActivityFollow';// 添加关注
const IsFollowByUserid = api + 'ActivityFollow/isFollowByUserId';// 是否关注过
const DelActivityForm = api + 'ActivityForm/delActivityForm';// 取消参与
const UpdateActivityForm = api + 'ActivityForm/updateActivityForm';// 编辑参与的
const GetCountByUserid = api + 'User/getUserInfo';       // 我的统计数
const SaveActivityUser = api + 'User/updataActivityUser';// 我的信息修改
const ShowActivityUser = api + 'User/getUserInfo';       // 我的信息获取
const FileList = api + 'ActivityFile/fileList';          // 发现文件-瀑布流
const VideoFavorite = api + 'video/videoFavorite';       // 视频点赞接口d
const ImageFavorite = api + 'Image/favorite';            //  图片点赞接口d
export default {
  DomainName,
  UrlName,
  IsPcName,
  GlobalUrl,
  GetShareInfo,
  UploadToken,
  ImageToken,
  WorldToken,
  GetAliToken,
  RecommendFile,
  GetRecommend,
  GetHomeOnList,
  GetChannelList,
  GetHomeChannel,
  GetActivities,
  GetHotActivity,
  GetActivitieById,
  UploadNew,
  VideoModel,
  VideoLatest,
  GetGetVCode,
  GetValidvode,
  GetVoteConfig,
  GetIpLimit,
  GetGetVoteList,
  VoteActivity,
  GetRelatedVideo,
  FileRelatedVideo,
  GetVideoInfo,
  GetImageInfo,
  GetActivityFormFields,
  GetUserActivityInfo,
  IsJoin,
  AddActivityForm,
  GetActivityForms,
  GetActivityFormContent,
  GetActivitieByUserid,
  GetMyActiviteInfo,
  GetUploadFileForMe,
  GetActivityFileByUserid,
  GetActivitieFollowByUserid,
  GetActivityMsgList,
  UpdataVideoAudit,
  UpdataImageAudit,
  DelEteVideo,
  DelEteImage,
  DelActivityFile,
  DelActivityMsgById,
  DelActivityFollow,
  AddActivityFollow,
  IsFollowByUserid,
  DelActivityForm,
  GetCountByUserid,
  UpdateActivityForm,
  SaveActivityUser,
  ShowActivityUser,
  FileList,
  VideoFavorite,
  ImageFavorite
}



// WEBPACK FOOTER //
// ./src/router/ajax.js